import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { formatCategoryName } from '../utils/textUtils';
import config from '../config/index.js';

const ProductCard = ({ product, onClick }) => {
  const { t, isArabic } = useLanguage();

  const handleCardClick = () => {
    if (onClick) {
      onClick(product);
    }
  };

  return (
    <motion.div
      whileHover={{ scale: 1.02, y: -5 }}
      className='bg-white border border-gray-200 rounded-xl p-4 cursor-pointer transition-all shadow-sm hover:shadow-lg'
      onClick={handleCardClick}
    >
      <div className='aspect-square mb-4 overflow-hidden rounded-lg bg-gray-50'>
        <img
          src={`${config.productsImagePath}/${product.image}`}
          alt={product.name}
          loading='lazy'
          className='object-contain w-full h-full p-2 transform transition-transform duration-300 hover:scale-105'
          onError={(e) => {
            e.target.src = config.placeholderImage;
          }}
        />
      </div>
      
      <h3 className={`text-base font-semibold mb-2 text-gray-900 line-clamp-2 ${isArabic ? 'text-right' : 'text-left'}`}>
        {product.name}
      </h3>
      
      <p className='text-primary-600 text-sm font-medium mb-1'>
        {formatCategoryName(product.category)}
      </p>
      
      {product.price && product.price !== '0' && (
        <p className='text-green-600 text-sm font-semibold mb-2'>
          Price: \
        </p>
      )}
      
      <div className={`text-xs text-gray-400 line-clamp-2 ${isArabic ? 'text-right' : 'text-left'}`}>
        {product.description || product.details || 'Quality assured medical product'}
      </div>
    </motion.div>
  );
};

export default ProductCard;